var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthWrongBase',[_vm._v(" El email y/o la contraseña introducidos no son válidos ")])}
var staticRenderFns = []

export { render, staticRenderFns }